<div class="row col-sm-12" style="padding-right: 0; margin-right: 0; margin-bottom: 2rem;">
  <div class="col-sm-5">
    <h3>{{ 'dashboard.revenue.title' | translate | titlecase }}</h3>
  </div>
  <div class="col-sm-7" style="padding-right: 0; margin-right: 0; margin-bottom: 1rem;"></div>
</div>

<div class="col-sm-6" style="margin-bottom: 3rem;">
  <wl-dashboard-revenue-dues-aging></wl-dashboard-revenue-dues-aging>
</div>

<div class="col-sm-6" style="margin-bottom: 3rem;">
  <wl-dashboard-revenue-non-dues-aging></wl-dashboard-revenue-non-dues-aging>
</div>

<div class="col-sm-12">
  <div class="col-sm-12 wl-text-center wl-dashboard-report-container" style="margin-top: 0;">
    {{ 'dashboard.revenue.reports.title' | translate }}&nbsp;&nbsp;
    
    <button 
      pButton 
      type="button" 
      class="btn btn-primary" 
      (click)="openARSummaryReport()"
      icon="pi pi-chart-bar"
      [label]="'dashboard.revenue.reports.accounts-receivable' | translate | titlecase">
    </button>&nbsp;&nbsp;

    <button 
      pButton 
      type="button" 
      class="btn btn-primary" 
      (click)="openRevenueByTypeReport()"
      icon="pi pi-chart-bar"
      [label]="'dashboard.revenue.reports.revenue-by-type' | translate | titlecase">
    </button>&nbsp;&nbsp;

    <button 
      pButton 
      type="button" 
      class="btn btn-primary" 
      (click)="openPaymentsAppliedReport()"
      icon="pi pi-chart-bar"
      [label]="'dashboard.revenue.reports.payments-applied' | translate | titlecase">
    </button>&nbsp;&nbsp;
  </div>
</div>